module.exports = __webpack_public_path__ + "img/Capture6.9209aa0e.jpg";